.root {
  display: none;
}

.toggle {
  align-items: center;
  background: transparent;
  border: 0;
  color: var(--color-text-on-primary);
  cursor: pointer;
  display: flex;
  height: 44px;
  justify-content: center;
  padding: 0;
  width: 44px;
}

.toggle:focus-visible {
  outline: 2px solid var(--color-background);
  outline-offset: 2px;
}

.panel {
  background: var(--color-background);
  border: 1px solid var(--color-muted);
  border-radius: 16px;
  box-shadow: 7px 10px 14px 3px rgba(0, 0, 0, 0.26);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  font-family: var(--font-family-base);
  left: 0;
  line-height: 2.5;
  max-width: calc(100vw - 2rem);
  padding: 1rem;
  position: absolute;
  top: 100%;
  width: 300px;
  z-index: 200;
}

.panel[hidden] {
  display: none;
}

@media (max-width: 767px) {
  .root {
    display: block;
    flex-shrink: 0;
    position: relative;
  }
}
